import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { useDropPrivileges } from "@/hooks/useDropPriviledges";
import { useAuth } from "../auth/Auth";
import DropPlaceholder from "./DropPlaceholder";
import CreateDrop from "./CreateDrop";
import { DropMode, type CurationComposerVariant } from "./dropComposer.types";
export { DropMode } from "./dropComposer.types";
interface PrivilegedDropCreatorProps {
  readonly activeDrop: ActiveDropState | null;
  readonly onCancelReplyQuote: () => void;
  readonly onDropAddedToQueue: () => void;
  readonly onAllDropsAdded?: (() => void) | undefined;
  readonly onExitFixedDropMode?: (() => void) | undefined;
  readonly wave: ApiWave;
  readonly dropId: string | null;
  readonly fixedDropMode: DropMode;
  readonly curationComposerVariant?: CurationComposerVariant | undefined;
}
export default function PrivilegedDropCreator(t0) {
  const $ = _c(31);
  const {
    activeDrop,
    onCancelReplyQuote,
    wave,
    dropId,
    fixedDropMode,
    onAllDropsAdded,
    onExitFixedDropMode,
    onDropAddedToQueue,
    curationComposerVariant: t1
  } = t0;
  const curationComposerVariant = t1 === undefined ? "default" : t1;
  const {
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const t2 = !!connectedProfile?.handle;
  const t3 = !!activeProfileProxy;
  const t4 = !wave.chat.enabled;
  const t5 = wave.participation.period?.min ?? null;
  const t6 = wave.participation.period?.max ?? null;
  const t7 = wave.participation.no_of_applications_allowed_per_participant ?? null;
  let t8;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5 || $[4] !== t6 || $[5] !== t7 || $[6] !== wave.chat.authenticated_user_eligible || $[7] !== wave.metrics.your_participation_drops_count || $[8] !== wave.participation.authenticated_user_eligible) {
    t8 = {
      isLoggedIn: t2,
      isProxy: t3,
      canChat: wave.chat.authenticated_user_eligible,
      canDrop: wave.participation.authenticated_user_eligible,
      chatDisabled: t4,
      submissionStarts: t5,
      submissionEnds: t6,
      maxDropsCount: t7,
      identityDropsCount: wave.metrics.your_participation_drops_count
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = wave.chat.authenticated_user_eligible;
    $[7] = wave.metrics.your_participation_drops_count;
    $[8] = wave.participation.authenticated_user_eligible;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const {
    submissionRestriction,
    chatRestriction
  } = useDropPrivileges(t8);
  if (submissionRestriction !== null && chatRestriction !== null) {
    let t9;
    if ($[10] !== chatRestriction || $[11] !== submissionRestriction) {
      t9 = <DropPlaceholder type="both" chatRestriction={chatRestriction} submissionRestriction={submissionRestriction} />;
      $[10] = chatRestriction;
      $[11] = submissionRestriction;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    return t9;
  }
  if (fixedDropMode === DropMode.CHAT && chatRestriction !== null) {
    let t9;
    if ($[13] !== chatRestriction) {
      t9 = <DropPlaceholder type="chat" chatRestriction={chatRestriction} />;
      $[13] = chatRestriction;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    return t9;
  }
  if (fixedDropMode === DropMode.PARTICIPATION && submissionRestriction !== null) {
    let t9;
    if ($[15] !== submissionRestriction) {
      t9 = <DropPlaceholder type="submission" submissionRestriction={submissionRestriction} />;
      $[15] = submissionRestriction;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    return t9;
  }
  let t9;
  if ($[17] !== chatRestriction || $[18] !== submissionRestriction) {
    t9 = {
      submissionRestriction,
      chatRestriction
    };
    $[17] = chatRestriction;
    $[18] = submissionRestriction;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== activeDrop || $[21] !== curationComposerVariant || $[22] !== dropId || $[23] !== fixedDropMode || $[24] !== onAllDropsAdded || $[25] !== onCancelReplyQuote || $[26] !== onDropAddedToQueue || $[27] !== onExitFixedDropMode || $[28] !== t9 || $[29] !== wave) {
    t10 = <CreateDrop activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} onAllDropsAdded={onAllDropsAdded} onExitFixedDropMode={onExitFixedDropMode} wave={wave} dropId={dropId} fixedDropMode={fixedDropMode} privileges={t9} onDropAddedToQueue={onDropAddedToQueue} curationComposerVariant={curationComposerVariant} />;
    $[20] = activeDrop;
    $[21] = curationComposerVariant;
    $[22] = dropId;
    $[23] = fixedDropMode;
    $[24] = onAllDropsAdded;
    $[25] = onCancelReplyQuote;
    $[26] = onDropAddedToQueue;
    $[27] = onExitFixedDropMode;
    $[28] = t9;
    $[29] = wave;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}